import {ErrorsReducer, ReducerFromState} from '../../@types/reducers';

export const getErrorMessage = (state: ReducerFromState<ErrorsReducer>): string => state.errors.message;